// extracted by mini-css-extract-plugin
export default {"notificationLoader":"saga_notificationLoader__S0SdR"};